var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Input } from '@angular/core';
import { AbstractComponent } from 'gp-admin-abstract';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent(elem) {
        var _this = _super.call(this, elem) || this;
        _this.elem = elem;
        /**
         * Текст компонента
         *
         * @type {string}
         */
        _this.text = '';
        /**
         * Текст ошибки либо состояние ошибки
         *
         * @type {string | boolean}
         */
        _this.error = false;
        /**
         * Выбрано или нет
         *
         * @type {boolean}
         */
        _this.checked = false;
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    CheckboxComponent.prototype.ngOnInit = function () {
        this._id = 'checkbox_' + (new Date()).getTime();
    };
    CheckboxComponent.prototype.writeValue = function (value) {
        this.checked = value;
    };
    CheckboxComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    CheckboxComponent.prototype.registerOnTouched = function (fn) {
    };
    CheckboxComponent.prototype.change = function () {
        this.propagateChange(this.checked);
    };
    Object.defineProperty(CheckboxComponent.prototype, "id", {
        get: function () {
            return !!this.customId ? this.customId : this._id;
        },
        enumerable: true,
        configurable: true
    });
    CheckboxComponent.prototype.showErrorText = function () {
        return ((typeof this.error === 'string') && !!this.error);
    };
    CheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-checkbox',
                    template: "\n<div class=\"gp-checkbox flex {{extraClass}}\">\n  <label class=\"gp-checkbox__label flex flex--align-center width-full cursor-pointer\">\n    <input type=\"checkbox\"\n           class=\"gp-checkbox__input\"\n           hidden\n           [checked]=\"checked\"\n           [(ngModel)]=\"checked\"\n           (ngModelChange)=\"change()\">\n    <span class=\"gp-checkbox__area icon icon--small icon--white icon--center-center icon--check margin--right-1\"></span>\n    <!--TODO: \u043A\u043E\u0433\u0434\u0430 \u043D\u0430\u0440\u0438\u0441\u0443\u044E\u0442, \u0442\u043E\u0433\u0434\u0430 \u0442\u0435\u043A\u0441\u0442 \u043E\u0448\u0438\u0431\u043A\u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C-->\n    <span class=\"gp-checkbox__text\" *ngIf=\"text\">{{text}}</span>\n    <ng-content *ngIf=\"!text\"></ng-content>\n  </label>\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n *  \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-checkbox\"\n */\n.gp-checkbox__input:checked + .gp-checkbox__area {\n  border-color: #00afec;\n  background-color: #00afec; }\n\n.gp-checkbox__area {\n  width: 2rem;\n  height: 2rem;\n  border: 0.1rem solid #d3d3d3;\n  border-radius: 0.3rem;\n  -moz-transition: all 150ms ease;\n  -o-transition: all 150ms ease;\n  -webkit-transition: all 150ms ease;\n  transition: all 150ms ease; }\n\n.gp-checkbox__text {\n  font: 1.3rem/1.5rem \"Roboto\", sans-serif;\n  color: #212121;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: CheckboxComponent,
                            multi: true
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    CheckboxComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    CheckboxComponent.propDecorators = {
        'customId': [{ type: Input },],
        'text': [{ type: Input },],
        'error': [{ type: Input },],
        'checked': [{ type: Input },],
    };
    return CheckboxComponent;
}(AbstractComponent));
export { CheckboxComponent };
//# sourceMappingURL=checkbox.component.js.map